import { connect } from "react-redux";

import { setToModel } from "../../../Engine/ActionCreators/AllActionCreators";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withControlDebugInfo } from "../../withControlDebugInfo";
import { withMetrics } from "../../withMetrics";
import { withResolvePaths } from "../../withResolvePaths";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withTestPageObjectRegistration } from "../../Services/TestPageObjects/PageObjectExposure";
import { withFocusManagement } from "../../Services/FocusManagement/withFocusManagement";
import { withExternalMountingEventReporting } from "../../Services/ExternalMountingEventReporting/withExternalMountingEventReporting";
import { AbsoluteResolvedModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { EvaluableProp, withEvaluators } from "../../withEvaluators";
import { checkIsSuitableToClick, externalOnClickHandler } from "../../../Engine/ActionCreators/ExternalOnClickAction";

import { TextArea } from "./TextArea";

interface TextAreaOwnProps {
    bindingPath: AbsoluteResolvedModelPath;
    viewModelSelect: ViewModelSelect;
    processEvaluableProp: <T>(state: FullFormState, prop: EvaluableProp<T>) => T;
    disabled?: boolean;
    disabled2?: EvaluableProp<boolean>;
}

const mapStateToProps = (state: FullFormState, ownProps: TextAreaOwnProps) => {
    const { bindingPath, disabled, disabled2, viewModelSelect, processEvaluableProp } = ownProps;
    const controlModel = viewModelSelect.controlModel(state, bindingPath);

    return {
        value: controlModel.value,
        disabled: processEvaluableProp(state, disabled2) || (disabled ?? controlModel.disabled),
        error: controlModel.error,
        warning: controlModel.warning,
        isTooltipEnabled: controlModel.isTooltipEnabled,
        isReadOnly: state.settings.isReadOnly,
        isLink: checkIsSuitableToClick(state.settings, bindingPath),
    };
};

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: TextAreaOwnProps) => {
    const { bindingPath } = ownProps;

    return {
        onChange: (value: string) => dispatch(setToModel(bindingPath, "value", value)),
        onClick: () => externalOnClickHandler(dispatch, bindingPath),
    };
};

export const TextAreaContainer = withMetrics(
    withResolvePaths(
        withViewModelSelect(
            withEvaluators(
                connect(
                    mapStateToProps,
                    mapDispatchToProps
                )(
                    withTestPageObjectRegistration(
                        withFocusManagement(withExternalMountingEventReporting(withControlDebugInfo(TextArea)))
                    )
                )
            )
        )
    )
);
